import { ACTION_TYPE } from '@skyscanner-internal/landing-pages-shared-constants/constants';
import { parseComponentName } from '@skyscanner-internal/landing-pages-shared-ui/src/components/common/MBD/useMBDContext';
import logMiniEventHelper from '@skyscanner-internal/landing-pages-shared-ui/src/mini-event/logMiniEventHelper';

const logGlobalComponentVisible = (componentConfigName: string) => () => {
  logMiniEventHelper({
    action_type: ACTION_TYPE.COMPONENT_VISIBLE,
    component_name: parseComponentName(componentConfigName),
  });
};

export default logGlobalComponentVisible;
